export default __webpack_public_path__ + "static/media/KOD0029-min.70d1c94d.webp";